import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site-info";

export default function HeroBanner() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20atmosphere%20with%20soft%20golden%20light%2C%20books%20stacked%20on%20a%20wooden%20desk%2C%20a%20dictionary%20open%20with%20letters%20floating%20gently%20upward%2C%20warm%20cream%20and%20amber%20tones%2C%20inspirational%20education%20theme%2C%20minimalist%20elegant%20composition%2C%20soft%20depth%20of%20field%2C%20editorial%20photography%20style&width=1600&height=900&seq=hero-banner-main&orientation=landscape"
          alt="Akeelah and the Bee 观影指南"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full mb-6 border border-background-50/30">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-amber-400 text-sm"></i>
            </div>
            <span className="text-sm text-background-50 font-medium">烂番茄新鲜度 86% · 励志经典</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
            {siteInfo.name}
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
            {siteInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/plot-analysis"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始探索
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}